import baseAPI from '../app/axios';

export default class RecurringMessageService {
  static async getData(orgId, id) {
    if (!orgId) {
      throw new Error('RecurringMessageService.getData: orgId undefined');
    }

    if (!id) {
      throw new Error('RecurringMessageService.getData: id undefined');
    }

    const response = await baseAPI.get(
      `/${orgId}/recurring_notifications/${id}?accounting=false`,
    );

    return response || {};
  }

  static async saveData(orgId, id, data) {
    if (!orgId) {
      throw new Error('RecurringMessageService.saveData: orgId undefined');
    }

    if (!id) {
      throw new Error('RecurringMessageService.saveData: id undefined');
    }

    if (!data) {
      throw new Error('RecurringMessageService.saveData: data undefined');
    }

    const response = await baseAPI.put(
      `/${orgId}/recurring_notifications/${id}`,
      { ...data },
    );

    return response?.id;
  }
}
